import sample_1 from './sample1.jpeg';

export const psaMultinorm1Impressions = {
    sample_1,
};
